<template>
    <div class="feed-wrapper">
      <div class="banner">
        <h1>说出你内心的声音...</h1>
        <h2>欢迎您提出宝贵的意见和建议，我们将积极采纳，更好的改善我们的服务</h2>
        <div>
          <el-button class="w120" type="primary" @click="_=>{$router.push('/addFeedBack');}">提建议</el-button>
          <el-button class="w120" plain v-if="userInfo"><router-link :to="{path:'/homepage',query:{id:userInfo.uId,activeName:'fifth'}}"  target="_blank" >我的反馈</router-link></el-button>
        </div>
      </div>
      <section>
        <div class="left mb60">
          <el-card>
            <div class="title"><span class="hd-title">热门建议</span><router-link to="/feed/all" class="all">全部&nbsp;></router-link></div>
            <ul class="hot-suggest">
              <li v-for="(item,index) in tableData" :key="index">
                <router-link :to="{path:'/feedBackDetail',query:{id:item.id,title:item.opinionTitle}}"> <h1><span>【{{typeData[item.opinionType]}}】</span>{{item.opinionTitle}}<i class="iconfont" v-if="item.attachment==='yes'">&#xe645;</i></h1></router-link>
                <p>
                  <span class="tag" v-for="(item,index) in item.labelArr" :key="index" @click="()=>$router.push({path:'/feed/all',query:{id:item}})">{{labelData[item]}}</span>
                </p>
                <p class="note" v-html="item.opinionContent"></p>
                <div class="bottom">
                  <div class="left">
                    <img :src="$api.getPic+item.uId" alt="">
                    <span class="name">{{item.uNickname}}</span>
                    <span class="time">{{item.createTime}}</span>
                  </div>
                  <div class="right">
                    <span class="view"><i class="iconfont">&#xe62d;</i>{{item.viewCount}}</span>
                    <span class="comment"><i class="iconfont">&#xe60a;</i>{{item.commentCount}}</span>
                    <span class="laud"><i class="iconfont">&#xe60b;</i>{{item.goodCount}}</span>
                  </div>
                </div>
                <div class="line"></div>
              </li>
            </ul>
            <!--<el-pagination-->
              <!--class="pagination"-->
              <!--align="center"-->
              <!--@current-change="handleCurrentChange"-->
              <!--:page-size.sync="pageSize"-->
              <!--:current-page.sync="pageNum"-->
              <!--background-->
              <!--layout="prev,pager,next,total"-->
              <!--:total="total"></el-pagination>-->
          </el-card>
        </div>
        <div class="right">
          <el-card class="mb30">
            <div class="title"><span class="hd-title">常见分类</span></div>
            <div class="tag-wrapper">
              <span class="tag tagBig" v-for="(item,key,index) in labelData" :key="index" @click="()=>$router.push({path:'/feed/all',query:{id:key}})">{{item}}</span>
            </div>
          </el-card>
          <el-card class="mb30">
            <div class="title"><span class="hd-title">常见问题</span></div>
            <question></question>
          </el-card>
        </div>
      </section>
      <cFooter></cFooter>
    </div>
</template>

<script>
import {mapState} from 'vuex';
import Question from './Question';
export default {
  name: 'index',
  computed: mapState(['userInfo']),
  components: {
    Question,
  },
  data() {
    return {
      pageNum: 1,
      pageSize: 5,
      total: 0,
      tableData: [],
      labelData: {},
      typeData: {},
    };
  },
  mounted() {
    this.getData();
    this.getCommentLabel();
    this.getCommentType();
  },
  methods: {
    handleCurrentChange() {},
    getData() {
      let param = {pageNum: this.pageNum, pageSize: this.pageSize};
      this.$api.selectHotFeedbackPage(param).then(res => {
        if (res.success) {
          this.tableData = res.data.map((item, index) => {
            item.labelArr = item.opinionLabel.split(',');
            return item;
          });
        } else {
          this.tableData = [];
        }
      });
    },
    getCommentType() {
      this.$api.getCommentType().then(res => {
        if (res.success) {
          this.typeData = res.data;
        }
      });
    },
    getCommentLabel() {
      this.$api.getCommentLabel().then(res => {
        if (res.success) {
          this.labelData = res.data;
        }
      });
    },
  },
};
</script>
<style scoped>
.note >>> p {
  color: #999 !important;
}
.note >>> p > span {
  color: #999 !important;
}
.note >>> p > a {
  color: #999 !important;
}
.note >>> p > a > u {
  color: #999 !important;
}
.note >>> p > strong {
  color: #999 !important;
}
</style>
<style scoped lang="less">
@import './common.less';
.tag-wrapper {
  padding-left: 20px;
  padding-top: 5px;
}
.tagBig {
  box-sizing: border-box;
  margin-top: 15px !important;
  height: 24px;
  line-height: 22px;
  border-radius: 13px;
  margin-left: 0 !important;
  margin-right: 10px;
}
/deep/ .el-button--default {
  background-color: transparent;
  a {
    color: #fff;
  }
  color: #fff;
}
/deep/ .el-button.is-plain:active {
  border-color: #fff;
  color: #333;
}
/deep/ .el-button.is-plain:active {
  background-color: #fff;
  color: #333;
}
/deep/ .el-button.is-plain:focus,
.el-button.is-plain:hover {
  border-color: #fff;
  color: #333;
  a {
    color: #333;
  }
}
.hot-suggest {
  li {
    &:last-child {
      .line {
        border-bottom: none !important;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/feedBack/Index.vue